<template>
  <div>
    <search v-model.trim="search" />
    <list-scroll v-if="filtered_files.length" ref="scroll" height="380px" class="mb-3 mt-3">
      <player-row v-for="file in filtered_files" :key="file.file_sln" :file="file">
        <list-state
          slot="controls"
          :value="is_active(file.file_sln)"
          @click="toggle_select(file.file_sln)"
        />
      </player-row>
    </list-scroll>

    <file-upload class="mt-3" @on-success="add_file" />
  </div>
</template>

<script>
  import cloneDeep from 'lodash-es/cloneDeep';
  import { filterName } from '@shared/helpers/filter';
  import Search from '../../_base/_fragments/search/index';
  import PlayerRow from '@autoinformer/components/media/_fragments/file-player-row';
  import ListState from '@shared/components/input/input-state-toggle';
  import FileUpload from '@autoinformer/components/media/_fragments/file-upload/index';

  export default {
    components: {
      Search,
      PlayerRow,
      ListState,
      FileUpload
    },

    props: {
      files: {
        type: Array,
        default: () => []
      },

      value: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        search: ''
      };
    },

    computed: {
      filtered_files: function() {
        return this.files.filter(f => filterName(this.search, f.description));
      }
    },

    methods: {
      is_active: function(sln_file) {
        return this.value.includes(sln_file);
      },

      toggle_select(sln_file) {
        const selected = cloneDeep(this.value);
        const index = selected.findIndex(f => f === sln_file);

        if (~index) {
          selected.splice(index, 1);
        } else {
          selected.push(sln_file);
        }

        this.$emit('input', selected);
      },

      add_file: function(file) {
        this.$emit('update:files', [file, ...this.files]);
        this.toggle_select(file.file_sln);
        this.$refs.scroll.refresh();
      }
    }
  };
</script>
